<template>
  <div class="smy__card-full-box page-org">
    <Card
      class="smy__card-full"
      :bordered="false"
      :padding="0"
    >
    <p slot="title">
      代理商管理
    </p>
    <p slot="extra" class="extra">
    </p>
    <div class="top">
      <div class="top-right" style="float:right;padding:17px 17px 0">
        <Button
          type="primary"
          class="search-button"
          style="margin-left:10px;"
          @click="newAgent"
        >新增代理商</Button>
      </div>
    </div>
    <div class="table" style="margin:17px">
      <Table
        stripe
        ref="table"
        :loading="listLoading"
        :columns="columns"
        :data="list"
        @on-selection-change="selection = $event"
      />
    </div>
    <Page
      show-total
      show-sizer
      class="page"
      placement="top"
      :current="pageIndex + 1"
      :total="coumt"
      :page-size-opts="pageSizeOpts"
      @on-change="pageIndexChange"
      @on-page-size-change="pageSizeChange"
      style="margin-left:17px;"
    />
    <AddAgent
    :agentId="agentId"
    :editModal = "editModal"
    :editTitle = "editTitle"
    :editRow = "editRow"
    @callback="loadList()"
    @backeditModal= "editModal = false"/>
    </Card>
  </div>
</template>

<script>
import {mapState} from 'vuex'
import AddAgent from './AddAgent'

export default {
  components: {
    AddAgent
  },
  data () {
    return {
      pageSize: 10,
      pageIndex: 0,
      listLoading: false,
      coumt: 0,
      list: [],
      editListModal: false, // 导出对话框
      agentId: -1,
      editModal: false,
      editTitle: '新增代理商',
      editRow: {}
    }
  },
  computed: {
    ...mapState('table', [
      'pageSizeOpts'
    ]),
    // 表格列 根据选中的列动态生成
    columns () {
      const allColumns = [
        {
          title: '操作',
          width: 140,
          align: 'center',
          fixed: 'right',
          render: (h, { row }) => {
            let deleteBtn = h('Poptip', {
              props: {
                confirm: true,
                title: '确认删除此内容吗？',
                width: 160,
                transfer: true
              },
              on: {
                'on-ok': () => this.deleteList(row.id)
              }
            }, [
              h('Button', {
                props: {
                  type: 'error',
                  size: 'small'
                },
                style: {
                  marginLeft: '10px'
                }
              }, ['删除'])
            ])
            let editBtn = h('Button', {
              props: {
                type: 'ghost',
                size: 'small'
              },
              on: {
                click: () => {
                  this.editTitle = '修改代理商'
                  this.agentId = row.id
                  this.editRow = row
                  this.editModal = true
                }
              }
            }, ['编辑'])
            if (row.isMain === 1) {
              return h('span', [editBtn])
            } else {
              return h('span', [
                editBtn,
                deleteBtn
              ])
            }
          }
        },
        {
          title: '代理商',
          key: 'agentName',
          width: 140
        },
        {
          title: 'CorpID',
          key: 'corpid',
          width: 140
        },
        {
          title: '渠道经理',
          key: 'channelName',
          width: 140
        },
        {
          title: '主管理员姓名',
          key: 'userName',
          width: 140
        },
        {
          title: '主管理员手机号',
          key: 'phone',
          width: 140
        },
        {
          title: '主管理员账号',
          key: 'loginName',
          width: 140
        },
        {
          title: '开户行',
          key: 'bankName',
          width: 140
        },
        {
          title: '对公账号',
          key: 'bankAccount',
          width: 140
        },
        {
          title: '代理等级',
          key: 'level',
          width: 140,
          render: (h, {row}) => {
            let priority = row.level
            let priorityName = ''
            if (priority === 0) {
              priorityName = '无'
            } else if (priority === 1) {
              priorityName = '铜牌'
            } else if (priority === 2) {
              priorityName = '银牌'
            } else if (priority === 3) {
              priorityName = '金牌'
            }
            return h('span', [priorityName])
          }
        },
        {
          title: '代理折扣',
          key: 'discount',
          width: 140
        },
        {
          title: '是否提交保证金',
          key: 'isPayDeposit',
          width: 140,
          render: (h, {row}) => {
            let priority = row.isPayDeposit
            let priorityName = ''
            if (priority === 0) {
              priorityName = '否'
            } else if (priority === 1) {
              priorityName = '是'
            }
            return h('span', [priorityName])
          }
        },
        {
          title: '激活/停用',
          width: 140,
          render: (h, {row}) => {
            if (row.enabled === 1) {
              row.switchStatus = true
            } else {
              row.switchStatus = false
            }
            return h('i-switch', {
              props: {
                value: row.switchStatus
              },
              on: {
                'on-change': (status) => {
                  if (status) {
                    this.enabled = 1
                  } else {
                    this.enabled = 0
                  }
                  this.listLoading = true
                  let url = '/agent/enabled'
                  let data = {
                    id: row.id,
                    enabled: this.enabled
                  }
                  this.$http.put(url, data).then(res => {
                    if (res.success) {
                      let msg = '保存成功'
                      this.$Message.success(msg)
                      this.listLoading = false
                    } else {
                      this.$Message.error(res.message)
                    }
                  })
                }
              }
            }, '')
          }
        },
        {
          title: ' ',
          key: ' '
        }
      ]
      return allColumns
    }
  },
  methods: {
    // 加载列表数据
    loadList () {
      this.listLoading = true
      this.$http.all([
        this.$http.get('/agent/list', {
          params: {
            pageIndex: this.pageIndex,
            pageSize: this.pageSize
          }
        }),
        this.$http.get('/agent/count', {
        })
      ]).then(this.$http.spread((res1, res2) => {
        this.list = res1.data
        this.coumt = res2.data
        this.listLoading = false
      }))
    },
    // 分页 每页大小 改变回调
    pageSizeChange (pageSize) {
      this.pageSize = pageSize
      this.loadList()
    },
    // 分页 页码 改变回调
    pageIndexChange (pageIndex) {
      this.pageIndex = (pageIndex - 1)
      this.loadList()
    },
    // 删除操作
    deleteList (itemId) {
      let url = `/agent?id=${itemId}`
      this.$http.delete(url).then(res => {
        if (res.success) {
          this.$Message.success('删除成功')
          this.loadList()
        } else {
          this.$Message.warning(res.message)
        }
      })
    },
    // 新建代理商
    newAgent () {
      this.editTitle = '新增代理商'
      this.agentId = -1
      this.editModal = true
    },
    // 修改密码
    resetPassword (val) {
      this.modalLoading = false
      setTimeout(() => {
        this.modalLoading = true
      }, 50)
      this.$refs[val].validate((valid) => {
        if (valid) {
          let data = {
            ...this.editListForm
          }
          let url = '/user'
          this.$http.put(url, data).then(res => {
            if (res.success) {
              let msg = '重置密码成功'
              this.loadList()
              this.$Message.success(msg)
              this.visible = false
              this.editListModal = false
              this.editListForm.password = ''
            } else {
              this.$Message.error(res.message)
            }
          })
        }
      })
    },
    // 保存编辑数据
    editList (val) {
      this.modalLoading = false
      setTimeout(() => {
        this.modalLoading = true
      }, 50)
      this.$refs[val].validate((valid) => {
        if (valid) {
          let data = {
            ...this.editListForm
          }
          let url = '/user'
          console.log(this.editListForm.id)
          if (this.editListForm.id) {
            this.$http.put(url, data).then(res => {
              if (res.success) {
                let msg = '修改成功'
                this.loadList()
                this.$Message.success(msg)
                this.editListModal = false
              } else {
                this.$Message.error(res.message)
              }
            })
          } else {
            this.$http.post(url, data).then(res => {
              if (res.success) {
                let msg = '新增成功'
                this.loadList()
                this.$Message.success(msg)
                this.editListModal = false
              } else {
                this.$Message.error(res.message)
              }
            })
          }
        }
      })
    }
  },
  created () {
    this.loadList()
  }
}
</script>

<style lang="less" scoped>
  .table {
    margin: 17px;
  }

  .page {
    margin-bottom: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/agentManage/agentManages/index.vue